import { Component, Input } from '@angular/core';
import { floor } from 'lodash';

@Component({
  selector: 'app-skilltrainingdash',
  templateUrl: './skilltrainingdash.component.html',
  styleUrl: './skilltrainingdash.component.scss'
})
export class SkilltrainingdashComponent {

  @Input() data: any;

  options: any;
  options2: any;
  totalGradesData : any;

  trainings: any[] = [];

  

  ngAfterViewInit() {
    this.options = {
      plugins: {
          legend: {
              labels: {
                  usePointStyle: true,
                  font: {
                    size: 14,
                    family: 'SSTArabic'
                  },
                  color: 'white'
              },
              position: "left"
          },
          tooltip: {
            enabled: false,
            external: this.external1
          }
      }
    };

    if (this.data?.stats?.gradecount) {
      this.generateTotalGradesData(this.data.stats.gradecount);
    }

    if(this.data?.data) {
      this.data.data.forEach(async (training: any) => {

        training.graphData = await this.generateData(training.gradecount);
        this.trainings.push(training);
      });

      console.log("this.trainings ====>>>>>",this.trainings);
    }
  }

  async generateTotalGradesData(totalGrades: any) {
    try {
      this.totalGradesData = await this.generateData(totalGrades);
    } catch (error) {
      console.error('Error generating total grades data:', error);
    }
  }

  totalling(data: any) {
    return data.reduce((a: any, b: { count: any; }) => a + b.count, 0)
  }


  async generateData(totalGrades: any): Promise<any> {
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');

    let totalUsers= totalGrades?.reduce((a: any, b: { count: any; }) => a + b.count, 0)

    return {
      labels: totalGrades?.map((item: any) => item._id.title || 'N/A'),
      datasets: [
        {
          data: totalGrades?.map((item: any) => floor((item.count/totalUsers)*100),2),
          backgroundColor: this.colors
        }
      ]
    };
  }

  colors = [
    '#FACB7D',
    '#6648FF',
    '#703D94',
    '#F7517F',
    '#3F4357',
    '#16CEB9',
  ]

  external1 = function (context: any) {
    // Tooltip Element
    let tooltipEl = document.getElementById('chartjs-tooltip');

    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';

      let style = 'background: white';
        style += '; color: black';
      tooltipEl.innerHTML = '<table dir="rtl" style="'+ style +'"></table>';
      
      document.body.appendChild(tooltipEl);
    }

    // Hide if no tooltip
    const tooltipModel = context.tooltip;
    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = '0';
      return;
    }

    // Set caret Position
    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltipModel.yAlign) {
      tooltipEl.classList.add(tooltipModel.yAlign);
    } else {
      tooltipEl.classList.add('no-transform');
    }

    function getBody(bodyItem: { lines: any }) {
      return bodyItem.lines;
    }

    // Set Text
    if (tooltipModel.body) {
      const titleLines = tooltipModel.title || [];
      const bodyLines = tooltipModel.body.map(getBody);

      let innerHtml = '<thead>';

      titleLines.forEach(function (title: string) {
        innerHtml += '<tr><th><span style="padding: 10px">' + title + '</span></th></tr>';
      });
      innerHtml += '</thead><tbody>';

      bodyLines.forEach(function (body: string, i: string | number) {
        const colors = tooltipModel.labelColors[i];
        let style = 'background:' + colors.backgroundColor;
        style += '; border-color:' + colors.borderColor;
        style += '; border-width: 2px';
        style += '; color: white';
        style += '; text-align: center; width: 100%';
        const span = '<span>' + body +'% </span>';
        innerHtml += '<tr style="' + style + '" ><td>' + span + '</td></tr>';
      });
      innerHtml += '</tbody>';

      let tableRoot = tooltipEl.querySelector('table');
      if (tableRoot) {
        tableRoot.innerHTML = innerHtml;
      }
    }

    const position = context.chart.canvas.getBoundingClientRect();

    // Display, position, and set styles for font
    tooltipEl.style.opacity = '1';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left =
      position.left + window.pageXOffset + tooltipModel.caretX + 'px';
    tooltipEl.style.top =
      position.top + window.pageYOffset + tooltipModel.caretY + 'px';
    tooltipEl.style.padding =
      tooltipModel.padding + 'px ' + tooltipModel.padding + 'px';
    tooltipEl.style.pointerEvents = 'none';
  }

  

}
